import React, { FC } from 'react';
import { AnalyticsSenderProvider } from '@funtech-int/yango-shared';

import { useHasSubscription } from '@/shared/hooks/useHasSubscription';
import { clientOnlyPage } from '@/shared/lib/clientOnly';
// TODO: отказаться от прямого импорта когда перейдем на @/scenarios/player https://st.yandex-team.ru/SAFT-8848
import { PlayerManager } from '@/scenarios/legacy-player/components/PlayerManager/PlayerManagerMain';
import { RememberedPages, useRemeberPage } from '@/shared/hooks/userRememberPage';

import { CounterOfferOnHome } from '../CounterOffer/CounterOfferOnHome';

import { AutoOpenPaymentWidgetOnHome } from './AutoOpenPaymentWidgetOnHome';
import { HomeComponent } from './HomeComponent';
import { MainPageHead } from './PageHead';

const HomeContent = clientOnlyPage(() => {
    useRemeberPage(RememberedPages.Main);

    const hasSubscription = useHasSubscription();

    return (
        <>
            <PlayerManager />
            <AnalyticsSenderProvider>
                <HomeComponent hasSubscription={hasSubscription} />
                <AutoOpenPaymentWidgetOnHome />
                <CounterOfferOnHome />
            </AnalyticsSenderProvider>
        </>
    );
});

export const Home: FC = () => (
    <>
        <MainPageHead />
        <HomeContent />
    </>
);

export default Home;
